<template>
<div style="">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 



<div class="columns is-centered mb-6">



<div class="column is-1"></div>
<div class="column is-10">
<div class="columns is-multiline has-background-grey-lighter">

<!-- <div style="margin-bottom:-1em;" @click="group_remove_confirm()" class="column isLink is-12 is-size-7 has-text-danger has-text-right has-text-weight-bold">
    <span class="icon is-small has-text-left"><i class="fas fa-trash"></i></span> 
    DELETE  
</div> v-if="!show_student_add" -->



    <div style="margin-bottom:-1em;" class="column is-8">
       &nbsp;&nbsp; {{this.course_title}} 
    </div>


    <div style="margin-bottom:-1em;" class="column is-3 has-text-right">
        Students : {{this.student_count}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <!-- <div v-else  style="margin-bottom:-1em;" class="column is-11 has-text-right"></div> -->

    <div style="margin-bottom:-1em;" class="column is-1">
        <a @click="group_remove_confirm()" class="button is-fullwidth has-background-danger-light has-text-danger"><span class="icon is-small"><i class="fas fa-trash"></i></span></a>
    </div>




    <div class="column is-2">
    <div class="columns is-gapless is-multiline">        

        <div class="column is-12">
        <span class="isLabel">Group*</span>
        <span @click="group_new_prompt()" class="is-pulled-right is-size-7 has-text-info isLink">New Code</span>
        <div class="control">
        <div class="select is-info is-fullwidth has-text-weight-bold">
            <select class="has-text-weight-bold has-text-danger" v-model="dataGrp.new_grp_code">
                    <!-- <option value="" disabled selected>...group code...</option> -->
                    <option v-for="(choice,index) in data_codes" :key="index" :value="choice.group_CODE">{{ choice.group_CODE }}</option>
            </select>
        </div>
        </div> 
        </div>    


    <div class="column is-12">
        <div class="control">
        <div class="select is-info is-fullwidth has-text-weight-bold">
            <select id="cmbCourse" ref="refCourse" @change="cour_change($event.target.selectedIndex)" class="has-text-weight-bold has-text-danger" v-model="dataGrp.new_grp_id_course">
                    <!-- <option value="" disabled selected>...course...</option> -->
                    <option v-for="(choice,index) in data_courses" :key="index" :value="choice.cour_ID">{{ choice.cour_CODE }}</option>
            </select>
        </div>
        </div>                
    </div>


    </div></div>
    <!-- END COLUMN ONE  -->
 

<div class="column is-1">
        <span class="isLabel"> &nbsp;&nbsp;Lang * </span>
        <div class="control">
        <div class="select is-fullwidth">
            <select @change="lang_change()" v-model="dataGrp.new_grp_lang">
                <option value="F">F</option>
                <option value="E">E</option>
            </select>
        </div>
        </div>
</div>  
<!-- END LANG !  -->


 <div class="column is-3">
<div class="columns is-gapless is-multiline"> 

<div class="column is-12"><span v-if="dataGrp.new_grp_sessann" class="is-pulled-right has-text-weight-bold has-background-warning"> &nbsp;&nbsp;{{dataGrp.new_grp_sessann}}&nbsp;&nbsp; </span>
<span class="isLabel"> &nbsp; </span>
    <p class="control has-icons-left">
        <flat-pickr
            placeholder="start date"
            v-model="dataGrp.new_grp_dt_start"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtStart">
        </flat-pickr>  
    <span class="icon is-small is-left"><i class="fas fa-calendar-alt"></i></span></p>
 </div>
<div class="column is-12">
    <p class="control has-icons-left">
         <flat-pickr
            @input="date_end_change()"
            placeholder="end date"
            v-model="dataGrp.new_grp_dt_end"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtEnd">
        </flat-pickr> 
    <span class="icon is-small is-left"><i class="fas fa-calendar-alt"></i></span></p>
</div>

 </div></div>
<!-- END COLUMN ONE  -->

<div class="column is-3">
<div class="columns is-gapless is-multiline"> 

  <div class="column is-12">  
    <span class="isLabel"> Prof(s) </span>
        <div class="control">
        <div class="select is-fullwidth">
            <select v-model="dataGrp.new_grp_prof1">
    <option value="NULL"></option>
    <option v-for="(prof,index) in data_profs" :value="prof.staff_ID"  :key="index" >{{ prof.prof }}</option>
            </select>
        </div>
        </div>
</div> 
<div class="column is-12">
        <div class="control">
        <div class="select is-fullwidth">
            <select  v-model="dataGrp.new_grp_prof2">
    <option value="NULL"></option>
    <option v-for="(prof,index) in data_profs" :value="prof.staff_ID"  :key="index" >{{ prof.prof }}</option>
            </select>
        </div>
        </div>
</div> 

 </div></div>
<!-- END COLUMN THR33  -->

<div class="column is-3">
<div class="columns is-gapless is-multiline"> 

  <div class="column is-9 mt-4 is-size-7 has-text-weight-bold"> 
    <button @click="students_add_show()" class="button is-fullwidth has-background-info-light has-text-gray">
        <span class="icon is-small has-text-left"><i class="fas fa-user-friends"></i></span> &nbsp;&nbsp;&nbsp;&nbsp; ADD STUDENTS    
    </button> 
   </div>

    <div v-if="show_student_add" class="column is-3 mt-4 is-size-7 has-text-weight-bold"> 
        <button @click="show_student_add=false" class="button is-fullwidth has-background-light has-text-gray">
            <span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span> &nbsp;&nbsp; FIN    
        </button> 
    </div>


<div v-if="show_student_add" class="column is-12">
<div class="columns is-gapless is-multiline"> 

<div class="column is-7">
        <p class="control has-icons-left"><input  v-model="search" v-on:keyup.enter="students_search()" class="input is-size-6 has-text-weight-bold is-fullwidth" type="text" placeholder="search">
        <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span></p>
</div>

<!-- <div class="column is-1"></div> -->

<div class="column is-5 has-text-weight-bold"> 
    <button @click="students_select_all()" class="button is-fullwidth has-background-success has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-hand-point-up"></i></span> &nbsp;&nbsp;SEL. ALL    
    </button> 
</div>



</div></div>
<!-- END LAST COL (STUD SEARCH .... ) -->




    <!-- <div class="column is-12 is-size-7 mt-3">&nbsp; STUDENTS : {{arr_studs_add.length}} </div> -->

 </div></div>
<!-- END COLUMN BUTTONS  -->

<!-- <div class="column is-12">
<div class="columns is-gapless is-multiline"> 
<div class="column is-3" v-for="(data,index) in arr_studs_add" :key="randomKey(index)">
    {{data}}
</div>
</div></div> -->
 
<div class="column is-12"> 
<div v-if="show_student_add" class="columns is-multiline mb-4 has-background-white box" style="padding-left:.5em;padding-right:.5em;">
<div class="column is-2 colBorderDark" style="" v-for ="(stud, ind) in student_add" :key="stud.student_ID"> 
<CompStudentBox :data="stud"  
    enabled='true'
    :key="stud.student_ID"
    btnType="ADD"

    @emit_click_add="emit_click_add"
    @emit_click_add_undo="emit_click_add_undo"
    > </CompStudentBox>
</div>
</div></div>


</div></div> <!-- END COLUMN 8  :selected="students_check_selected(stud.student_ID)" -->


<!-- <div class="column is-4">

<div class="columns is-centered is-gapless is-multiline mb-6">
<div class="column is-8 is-size-6 has-text-weight-bold has-background-success-light"> ADD STUDENTS ! </div>
<div class="column is-8">
<div class="columns is-multiline is-gapless" style="margin-bottom:0em;">
    <div class="column is-6">
        <p class="control has-icons-left"><input  v-model="search" v-on:keyup.enter="students_search()" class="input is-size-6 has-text-weight-bold is-fullwidth" type="text" placeholder="search">
        <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span></p>
    </div>
    <div class="column is-paddingless has-text-centered is-size-6 has-text-weight-bold is-3"><button @click="students_search()"  title="Search Students" class="button is-fullwidth has-background-grey-dark has-text-warning"><span class="icon is-medium"><i class="fas fa-search"></i></span></button></div>
    <div class="column is-paddingless has-text-centered is-size-6 has-text-weight-bold is-3"><button @click="students_add_save()" title="OK" class="button is-fullwidth has-background-grey-dark has-text-white"><span class="icon is-medium"><i class="fas fa-thumbs-up"></i></span></button></div>
</div>
</div>
<div class="column is-8">
<div class="colBorder" style="padding:6px;" v-for ="(stud, ind) in student_add" :key="randomKey(ind)"> 
<CompStudentBox :data="stud"  
    enabled='true'
    :key="randomKey()"
    btnType="ADD"
    @emit_click_add="emit_click_add"
    @emit_click_add_undo="emit_click_add_undo"
    > </CompStudentBox>
</div>
</div>
</div>
</div> -->
<!-- ******************** END STUD COL !!!!!!!!!!!!!  -->
<!-- END ADD STUDENTS -->


</div><!-- END MAIN COLUMNS  -->

 

</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import CompStudentBox  from '@/components/Comp_Student_Box';

export default {
        props: [ 'batchIndex' , 'dataGrp' , 'data_profs' , 'data_codes' , 'data_courses'],
        components: { CompStudentBox },

        data() {
            return {
                 isLoading:false,
                 search:'',
                 arr_studs_add:[],
                 student_add:[],
show_student_add:false,
student_count:0,

course_combo_index:-1,
course_title:'',

                    config: { // FLATPICKER
                        altFormat: "M j, Y",
                        altInput: true
                    },

            }
        },
 
    
created() {
        this.student_count = this.dataGrp.students.length 
        this.course_title = this.dataGrp.new_grp_course_title
}, //END CREATED

methods: {

students_check_selected:function(id) {
// CHECK IF STUDENT ALREADY SELECTED !
    for (var i = 0; i < this.arr_studs_add.length; i++) {
        if (this.arr_studs_add[i] == id) { return true}
    } // END FOR
    return false
},
students_select_all:function() {
// CHECK IF STUDENT ALREADY SELECTED !
    for (var i = 0; i < this.student_add.length; i++) {
        this.arr_studs_add.push(this.student_add[i].student_ID)
    } // END FOR
    this.student_count = this.arr_studs_add.length
    this.show_student_add = false
},



students_add_show:function() {
// SHOW ADD STUDENT MODAL
    // document.querySelector('#myModalStudentAddGroup').classList.add('is-active');
  
    this.show_student_add = true
// LOAD GRP STUDENTS BY DEFAULT -- CHECK IF ANYTHING FIRST
    if (this.student_add.length == 0) {
        this.search = this.dataGrp.new_grp_code
        this.students_search()
    }
},

students_add_hide:function() {
// HIDE ADD STUDENT MODAL
    document.querySelector('#myModalStudentAddGroup').classList.remove('is-active');
},

students_search:function() {

    this.arr_studs_add = [] // CLEAR ADD
        if (this.search == '') {return;}

        this.isLoading=true;

    var query =  `SELECT  TOP (100) MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, 
    MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_blnActive, MyMEQ_STUDENT.student_blnComplete, MyMEQ_STUDENT.student_PhotoPath, 
    MyMEQ_PROGRAM.prog_ID,MyMEQ_PROGRAM.prog_CODE, COUNT(MyMEQ_COURSESTUDENT.group_ID) AS cnt, MAX(MyMEQ_GROUP.group_datEND) AS maxDt
    ,student_rueNUM + ' ' + student_Address + '   ' + student_apt + ',  ' + student_City AS ADDRESS,prog_TITRE_F,prog_TITRE_E, student_TelHome, student_TelOther, student_eMail ,  student_SecretCode, student_CreateDate
    FROM  MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID LEFT OUTER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID LEFT OUTER JOIN  MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID        
    WHERE  student_GRPCODE LIKE '` + this.search  + `%25' OR 
    student_lNAME LIKE '` + this.search  + `%25' OR 
    student_CodePerm LIKE '` + this.search  + `%25'  
    GROUP BY MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, 
    MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_blnActive, MyMEQ_STUDENT.student_blnComplete, MyMEQ_STUDENT.student_PhotoPath, 
    MyMEQ_PROGRAM.prog_ID,MyMEQ_PROGRAM.prog_CODE,prog_TITRE_F,prog_TITRE_E,student_rueNUM,student_Address ,student_apt,  student_City, student_TelHome, student_TelOther, student_eMail,  student_SecretCode , student_CreateDate  
    ORDER BY student_lNAME,student_fNAME`;

        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { this.student_add = res.data
        this.isLoading=false;   })  
},
emit_click_add:function(studentID) {
    this.arr_studs_add.push(studentID)
    this.student_count = this.arr_studs_add.length

    this.$emit('emit_student_list', this.batchIndex ,this.arr_studs_add)
    // this.dataGrp.students = this.arr_studs_add
    //this.is_changed = true;
},
emit_click_add_undo:function(studentID) {
   // this.is_changed = true;
    const index = this.arr_studs_add.indexOf(studentID);
    if (index > -1) {
    this.arr_studs_add.splice(index, 1);
    this.$emit('emit_student_list', this.index ,this.arr_studs_add)
    // this.dataGrp.students = this.arr_studs_add
    }
},

lang_change:function() {
    
    if (this.course_combo_index > -1) {
        if (this.dataGrp.new_grp_lang == 'E') 
        {this.course_title = this.data_courses[this.course_combo_index].cour_TITRE_E}
        else {this.course_title = this.data_courses[this.course_combo_index].cour_TITRE_F
        }
    } // END CHECK COUR SELECT
    this.dataGrp.new_grp_course_title = this.course_title
},

cour_change:function(selIndex) {
    this.course_combo_index = selIndex // FOR TITLE

// GET PONDERATION FOR COURSE
    this.dataGrp.ponderation=[]
//    var query = "SELECT * FROM MyMEQ_COUR LEFT OUTER JOIN myMEQ_COUR_POND ON MyMEQ_COUR.cour_ID = myMEQ_COUR_POND.cour_ID WHERE myMEQ_COUR.cour_ID = " + this.dataGrp.new_grp_id_course
    var query = "SELECT * FROM myMEQ_COUR_POND WHERE cour_ID = " + this.dataGrp.new_grp_id_course
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.dataGrp.ponderation = res.data
        this.lang_change()
    })
},












date_end_change:function() {
// GET SESSION ANNEE
    var sessann = moment(this.dataGrp.new_grp_dt_end).format('M')
    if (sessann <= 4)
    { this.dataGrp.new_grp_sessann = 'H'}
    else if (sessann > 4 && sessann <= 8)
    { this.dataGrp.new_grp_sessann = 'E'}
    else
    { this.dataGrp.new_grp_sessann = 'A'}
    this.dataGrp.new_grp_sessann += "-" + moment(this.dataGrp.new_grp_dt_end).format('YY')
},

group_new_prompt:function() {
    // PROMPT FOR NEW QUOTE NUMbER
    this.$snotify.prompt('NEW GROUP !! '  , {
    timeout: 20000, showProgressBar: true, closeOnClick: false, pauseOnHover: true, position:"centerCenter", notifyType:'warning',
        buttons: [
            {text: 'OK', action: (toast) => this.group_new_pop(toast), bold: false},
            {text: 'Cancel', action: (toast) => {this.$snotify.remove(toast.id); }, bold: true},
        ], placeholder: 'Enter Group Code'
    });
},

group_new_pop:function(toast) {
    // CHECK NUMBER UNIQUE
    if (toast.value.trim() == '') {alert ('Invalid') ; return ; }

    var obj = {};
    obj.group_CODE = toast.value
    this.data_codes.push(obj); 

    this.dataGrp.new_grp_code = toast.value
    this.$snotify.remove(toast.id);

},





group_remove_confirm:function() {
    // this.note_index = index 
    // this.data_notes[index].is_selected = !this.data_notes[index].is_selected
    this.$snotify.confirm('DELETE COURSE ?', { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
    position: "rightCenter",
        buttons: [
            {text: 'Yes', action: (toast) => this.group_remove_do(toast)},
            {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
        ]  });
},

group_remove_do:function(toast,index) {
this.$snotify.remove(toast.id)
this.$emit('emit_course_remove',this.index)

},

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},
}, // END METHODS




} // END EXPORT
</script>